import { render, staticRenderFns } from "./trade-service-parts-display.vue?vue&type=template&id=0b92dd0a&scoped=true&"
import script from "./trade-service-parts-display.vue?vue&type=script&lang=js&"
export * from "./trade-service-parts-display.vue?vue&type=script&lang=js&"
import style0 from "../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css?vue&type=style&index=0&id=0b92dd0a&scoped=true&lang=css&"
import style1 from "./trade-service-parts-display.vue?vue&type=style&index=1&id=0b92dd0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b92dd0a",
  null
  
)

export default component.exports